export const SelectContainer = ({children}) => {
    return(
        <div className="max-w-md mb-8 flex-1">{children}</div>
    )
}